/* eslint-disable @typescript-eslint/ban-types */
import { ProjectDto } from '@api/projects/interfaces';
import { IParticipant } from '@interfaces/interfaces';
import { Action, createAction, props } from '@ngrx/store';
import {AppStateSettings} from './AppState';

export const SET_STATE = '[Settings] Set State';
export const SET_DEV_STATE = '[Settings] Set Dev State';
export const SET_APP_STATE = '[Settings] Set App State';
export const CHANGE_SETTING = '[Settings] Change Setting';
export const CHANGE_DEV_SETTING = '[Settings] Change Dev Setting';
export const CHANGE_APPSTATE_SETTING = '[Settings] Change AppState Setting';

export class SetStateAction implements Action {
  readonly type = SET_STATE
  constructor(public payload: object) {}
}

export class ChangeSettingAction implements Action {
  readonly type = CHANGE_SETTING
  constructor(public payload: object) {}
}

export class SetDevStateAction implements Action {
	readonly type = SET_DEV_STATE
	constructor(public payload: object) {}
}

export class ChangeDevSettingAction implements Action {
	readonly type = CHANGE_DEV_SETTING
	constructor(public payload: object) {}
}

export const settingStateAction = createAction('[Settings] Set State', props<Record<string, any>>());
export const settingChangeAction = createAction('[Settings] Change Setting', props<Record<string, any>>());

export const devSettingStateAction = createAction('[Dev Settings] Set State', props<Record<string, any>>());
export const devSettingChangeAction = createAction('[Dev Settings] Change Setting', props<Record<string, any>>());

export const appStateSetAction = createAction('[AppState] set app state', props<AppStateSettings>());
export const appStateChangeAction = createAction('[AppState] change app state', props<Partial<AppStateSettings>>());
export const activeProjectChange = createAction('[AppState] active project change', props<{activeProjectID: string}>());
export const activeProjectChanged = createAction('[AppState] active project changed', props<{project: ProjectDto}>());
export const activeProjectLoadFailed = createAction('[AppState] active project load failed');

export const activeParticipantChange = createAction('[AppState] active participant change', props<{activeParticipantID: string}>());
export const activeParticipantChanged = createAction('[AppState] active participant changed', props<{participant: IParticipant }>());
export const activeParticipantLoadFailed = createAction('[AppState] active participant load failed');

export type Actions =
	SetDevStateAction | ChangeDevSettingAction |
	SetStateAction | ChangeSettingAction;
